import React from "react"
import Toggle from "react-toggle"
import { StaticBackdrop } from "../modal"
import { ToggleWithBackdropProps } from "../types/toggle"

export const ToggleWithBackdrop = (props: ToggleWithBackdropProps) => {

    return (
        <StaticBackdrop>
            <div className="d-flex align-items-center mb-2">
                <h5 className="mr-2 mb-0 pb-0 border-0">{props.title}</h5>
                <Toggle
                    checked={props.isEnabled}
                    icons={false}
                    onChange={e => props.onChangeCallback(e.target.checked)}
                />
            </div>

            {props.description &&
                <small className="text-muted">
                    {props.description}
                </small>
            }
        </StaticBackdrop>
    )
}


// WEBPACK FOOTER //
// ./src/common/toggle/ToggleWithBackdrop.tsx